import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserApiService } from 'src/app/user-api.service';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-consommations',
  templateUrl: './consommations.component.html',
  styleUrls: ['./consommations.component.scss']
})
export class ConsommationsComponent implements OnInit, AfterViewInit {

  constructor( private userApiService: UserApiService, public router: Router, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer)
   {    }
 
   FactureUser = []
   userPaieFormu = null 
   paymode : string = null
   payment : boolean 
   card : any
  
 
   ngOnInit() {
       this.SubscribeUserDetailPayment()
       this.SubscribeConsommation()
   }
 
   ngAfterViewInit(): void {
    this.createChart();
  }
 
  startdate = new Date('2011-01-01T00:00:00Z');
  enddate = new Date()
   SubscribeFactureUser(){
     this.userApiService.getFactureUser(this.startdate, this.enddate).subscribe( x => {this.FactureUser=x.data.list} )
   }
 
 
   SubscribeConsommation(){
     this.userApiService.getPaiement().subscribe( 
       res => { this.card = res.data.card; this.payment = res.success},
       err => { this.payment = err.error.success } )
   }
 
   SubscribeUserDetailPayment(){
     this.userApiService.getUserDetailPaiement().subscribe( res => { 
        this.paymode = res.data.paymode; 
        this.userPaieFormu=res.data.contract.url_change_package} )
   }
 
 
 
   redirectFormu(){
     window.location.href= this.userPaieFormu; 
   }
 
 
   loaded : boolean = false;


   createChart() {
    const ctx = document.getElementById('energyChart') as HTMLCanvasElement;

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Janv', 'Fév', 'Mai'],
        datasets: [{
          label: 'kWh',
          data: [10, 8, 9],
          backgroundColor: '#ff6600',
          borderRadius: 3,
          // 🔹 Réduction de la largeur des barres :
          barPercentage: 0.5,        // 1 = pleine largeur, 0.5 = moitié
          categoryPercentage: 0.6    // espace entre les groupes
        }]
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value) => value + ' kWh'
            }
          }
        },
        plugins: {
          legend: { display: false }
        }
      }
    });
    }

 
 }
 